/**
 * Số chữ số thập phân minor units theo ISO 4217 cho các đơn vị Goppy hỗ trợ — MỘT nguồn.
 *
 * 🔴 US-E23.F1-0789 (review PR #790 · M2): trước bản này bảng `{VND:0, JPY:0, USD:2, EUR:2}` được
 * chép tay ở BA chỗ (`notification-templates/render.ts`, `ui-kit/format/money.ts`, và bản PDF vừa
 * thêm). Ba bảng cho một sự thật là ba chỗ có thể lệch — thêm một đơn vị tiền mới ở một chỗ thì hai
 * bề mặt kia lặng lẽ chia sai 100 lần. Nay cả ba đọc từ đây.
 *
 * Đơn vị lạ ⇒ mặc định 2 (đa số ISO 4217). VND/JPY = 0.
 */
export const MINOR_UNIT_DIGITS: Readonly<Record<string, number>> = {
  VND: 0,
  JPY: 0,
  USD: 2,
  EUR: 2,
};

/** Số chữ số lẻ của `currency`; không có trong bảng ⇒ 2. */
export function minorUnitDigits(currency: string): number {
  // `Object.hasOwn` (review #790 · L6): khoá prototype (`constructor`, `__proto__`) không phải mã tiền.
  return Object.hasOwn(MINOR_UNIT_DIGITS, currency) ? MINOR_UNIT_DIGITS[currency]! : 2;
}
